import { Paper, TableCell } from "@mui/material"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableBody from "@mui/material/TableBody"
import Table from "@mui/material/Table"
import { MnemonicData } from "@custom-types/graphs"

import {
  getMnemColumnIndex,
  getScenarioColumnIndex,
} from "@features/graph/details/components/MnemonicTable/helpers"
import EditableCell, { EditType } from "@components/EditableCell"

interface MnemonicTableProps {
  data: MnemonicData
  editable?: boolean
  onEdit?: (timestep: string, newValue: string) => void
}

const MnemonicTable = (props: MnemonicTableProps) => {
  const scenarioIndex = getScenarioColumnIndex(props.data)
  const mnemIndex = getMnemColumnIndex(props.data)

  const columns = props.data.columns.filter((_column, i) => i !== scenarioIndex && i !== mnemIndex)
  const rows = props.data.rows.map((row) =>
    row.filter((_value, i) => i !== scenarioIndex && i !== mnemIndex),
  )

  const handleBlur = (timestep: string, newValue: string) => {
    if (!props.editable || !props.onEdit) return

    props.onEdit(timestep, newValue)
  }

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {columns.map((column: string) => (
              <TableCell key={column}>
                <strong>{column}</strong>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map(([timestep, value], i) => (
            <TableRow key={i} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
              <TableCell>{timestep}</TableCell>
              <EditableCell
                value={value ?? null}
                type={EditType.Number}
                editable={props.editable}
                onBlur={(newValue) => handleBlur(timestep as string, newValue)}
              />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default MnemonicTable
